import React, { useState } from "react";
import { useLocation } from "react-router-dom";

export const useIsSuspect = () => {
  const location = useLocation();
  const [isSuspect] = useState(location.pathname.includes("suspect"));

  return isSuspect;
};
